// GameStory_pounceWindows.tsx

import * as React from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import { KitchenArrivalRow } from "./RallyBoardPopup";
import {
  PlayerIndexMap,
  renderIdentityFromInsightsPlayerId,
  RenderPlayerIdentity,
  toDisplayPlayerLabel,
} from "./GameStoryDialog_UPDATED";
import { ActiveRallyVideo } from "./ActiveRallyVideo";
import { FirefightClip } from "./GameStory_firefights";
import { CvJson } from "../../shared/types/cvJson";
import { PounceWindowRow } from "../../shared/types/pounceEtc";

import { text } from "stream/consumers";
import PounceCatIcon from "./pounceCatIcon";

// export type PounceRequiredMovementPoint = {
//   x: number;
//   y: number;
// };

export type CourtPointXY = {
  x: number;
  y: number;
};

export type PounceRequiredMovement = {
  enabled: boolean;
  startPoint: CourtPointXY | null;
  endPoint: CourtPointXY | null;
  firstAttackablePoint: CourtPointXY | null;
  bestAttackPoint: CourtPointXY | null;
  distanceFeet: number | null;
  dxFeet: number | null;
  dyFeet: number | null;
  direction:
    | "forward"
    | "forward-left"
    | "forward-right"
    | "left"
    | "right"
    | "backward"
    | "other"
    | null;
};

export type PounceOverlay = {
  enabled: boolean;
  focusedPlayerId: number;
  opponentPlayerId: number;
  triggerShotNumber: number;
  overlayStartMs: number | null;
  overlayEndMs: number | null;
  entryMs: number | null;
  exitMs: number | null;
  pounceResult: "taken" | "not_taken" | null;
  opponentContact: {
    x: number | null;
    y: number | null;
    z: number | null;
    ms: number | null;
  };
  playerAtOpponentImpact: {
    x: number | null;
    y: number | null;
    distanceToKitchenLineFeet: number | null;
  };
  firstAttackablePoint: {
    x: number | null;
    y: number | null;
    z: number | null;
    ms: number | null;
  } | null;
  bestAttackPoint: {
    x: number | null;
    y: number | null;
    z: number | null;
    ms: number | null;
  } | null;
  movementDistanceFeet: number | null;
  movementDirection:
    | "forward"
    | "forward-left"
    | "forward-right"
    | "left"
    | "right"
    | "backward"
    | "other"
    | null;
  peakPoint: {
    x: number | null;
    y: number | null;
    z: number | null;
  } | null;
  peakHeightOverNet: number | null;
  requiredMovement: PounceRequiredMovement;

  pounceShotNumber: number | null;
  pounceShotStartMs: number | null;
  pounceShotEndMs: number | null;


  pounceShotTrajectory: {
    start: {
      x: number | null;
      y: number | null;
      z: number | null;
      ms: number | null;
    } | null;
    peak: {
      x: number | null;
      y: number | null;
      z: number | null;
      ms?: number | null;
    } | null;
    end: {
      x: number | null;
      y: number | null;
      z: number | null;
      ms: number | null;
    } | null;
  } | null;
};

// export type PounceWindowRow = {
//   pounceResult: "taken" | "not_taken";
//   recipientTeamWonRally: boolean;

//   didRecipientHitNextShot: boolean;
//   recipientTeam: 0 | 1;
//   winningTeam: 0 | 1 | null;

//   rallyIndex: number;
//   shotIndex: number;
//   pointKey: string;

//   focusedPlayerId: number;
//   opponentPlayerId: number;

//   zoneAtOpponentImpact: "kitchen" | "transition" | "other";

//   opponentContact: {
//     x: number | null;
//     y: number | null;
//     z: number | null;
//     ms: number | null;
//   };

//   playerAtOpponentImpact: {
//     x: number | null;
//     y: number | null;
//     distanceToKitchenLineFeet: number | null;
//   };

//   attackBand: {
//     entered: boolean;
//     entryMs: number | null;
//     exitMs: number | null;
//     firstAttackablePoint: {
//       x: number | null;
//       y: number | null;
//       z: number | null;
//       ms: number | null;
//     } | null;
//     bestAttackPoint: {
//       x: number | null;
//       y: number | null;
//       z: number | null;
//       ms: number | null;
//     } | null;
//     beforeBounceWindow: boolean | null;
//     afterBounceWindow: boolean | null;
//   };

//   movementToBestAttackPoint: {
//     dxFeet: number | null;
//     dyFeet: number | null;
//     distanceFeet: number | null;
//     direction:
//       | "forward"
//       | "forward-left"
//       | "forward-right"
//       | "left"
//       | "right"
//       | "backward"
//       | "other"
//       | null;
//   };

//   ballGeometry: {
//     peakX: number | null;
//     peakY: number | null;
//     peakZ: number | null;
//     peakHeightOverNet: number | null;
//     speedMph: number | null;
//   };

//   scores: {
//     readiness: number;
//     commit: number;
//     feasibility: number;
//   };

//   opportunityKind:
//     | "transition-pounce"
//     | "kitchen-pounce"
//     | "poach-like"
//     | "erne-ready"
//     | "other";

//   summaryLabel: string;
// };

type PounceSortKey =
  | "commit"
  | "readiness"
  | "rally"
  | "shot"
  | "time"
  | "initiator"
  | "recipient"
  | "distanceMoved";

type PounceSortDir = "asc" | "desc";

function pct01To100(n: number | null | undefined): number | null {
  if (typeof n !== "number" || !Number.isFinite(n)) return null;
  return Math.round(n * 100);
}

function fmtFeet(n: number | null | undefined, digits = 1): string {
  if (typeof n !== "number" || !Number.isFinite(n)) return "—";
  return `${n.toFixed(digits)} ft`;
}

function fmtMs(n: number | null | undefined): string {
  if (typeof n !== "number" || !Number.isFinite(n)) return "—";
  return `${Math.round(n)} ms`;
}

function buildTakenLabel(row: PounceWindowRow): string {
  return row.pounceResult === "taken" ? "Taken" : "Not Taken";
}

function buildRallyResultLabel(row: PounceWindowRow): string {
  return row.recipientTeamWonRally
    ? "Won"
    : row.recipientTeamWonRally === null
      ? "Unknown"
      : "Lost";
}

function buildPounceMoveLabel(row: PounceWindowRow): string {
  const d = row.movementToBestAttackPoint.distanceFeet;
  const dir = row.movementToBestAttackPoint.direction;
  if (typeof d !== "number" || !Number.isFinite(d)) return "—";
  return `${d.toFixed(1)} ft${dir ? ` ${dir}` : ""}`;
}

function getPounceTimeFromContactMs(row: PounceWindowRow): number | null {
  const bestMs = row.attackBand.bestAttackPoint?.ms;
  const contactMs = row.opponentContact.ms;
  if (typeof bestMs !== "number" || typeof contactMs !== "number") return null;
  return bestMs - contactMs;
}

function buildPounceTimeLabel(row: PounceWindowRow): string {
  return fmtMs(getPounceTimeFromContactMs(row));
}

function buildPounceStrength(row: PounceWindowRow): {
  commit: number | null;
  readiness: number | null;
  feasibility: number | null;
} {
  return {
    commit: pct01To100(row.scores.commit),
    readiness: pct01To100(row.scores.readiness),
    feasibility: pct01To100(row.scores.feasibility),
  };
}

function buildOpportunityKindLabel(
  kind: PounceWindowRow["opportunityKind"],
): string {
  if (kind === "transition-pounce") return "Transition pounce";
  if (kind === "kitchen-pounce") return "Kitchen pounce";
  if (kind === "poach-like") return "Poach-like";
  if (kind === "erne-ready") return "Erne-ready";
  return "Other";
}

function teamOfPlayer(playerId: number): 0 | 1 {
  return playerId === 0 || playerId === 1 ? 0 : 1;
}

function getTriggerShotNumber(row: PounceWindowRow): number {
  return row.shotIndex + 1;
}

function buildTriggerLabel(row: PounceWindowRow): string {
  return `Opp p${row.opponentPlayerId} · S${getTriggerShotNumber(row)}`;
}

// function buildRecipientLabel(row: PounceWindowRow): string {
//   return `For p${row.focusedPlayerId}`;
// }

function buildInitiatorSubLabel(row: PounceWindowRow): string {
  return `Shot ${row.shotIndex + 1}`;
}

function getPounceWindowDurationMs(row: PounceWindowRow): number | null {
  const entryMs = row.attackBand.entryMs;
  const exitMs = row.attackBand.exitMs;
  if (
    typeof entryMs !== "number" ||
    !Number.isFinite(entryMs) ||
    typeof exitMs !== "number" ||
    !Number.isFinite(exitMs)
  ) {
    return null;
  }
  return Math.max(0, exitMs - entryMs);
}

function getStableInitiatorId(
  row: PounceWindowRow,
  insightsToCvPlayerIndex: PlayerIndexMap,
): number {
  void insightsToCvPlayerIndex;
  return row.opponentPlayerId;
  //return insightsToCvPlayerIndex[row.opponentPlayerId];
}

function getStableRecipientId(
  row: PounceWindowRow,
  insightsToCvPlayerIndex: PlayerIndexMap,
): number {
  void insightsToCvPlayerIndex;
  return row.focusedPlayerId;
  //return insightsToCvPlayerIndex[row.focusedPlayerId];
}

function buildPounceTakenBadge(row: PounceWindowRow): React.ReactNode {
  const taken = row.pounceResult === "taken";

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        px: 1.1,
        py: 0.38,
        borderRadius: 999,
        fontSize: 12,
        fontWeight: 900,
        letterSpacing: 0.6,
        lineHeight: 1,
        border: "1px solid",
        color: taken ? "#1f7a36" : "#b42318",
        bgcolor: taken ? "rgba(31,122,54,0.10)" : "rgba(180,35,24,0.10)",
        borderColor: taken ? "rgba(31,122,54,0.35)" : "rgba(180,35,24,0.35)",
        boxShadow: taken
          ? "0 0 0 1px rgba(31,122,54,0.06) inset"
          : "0 0 0 1px rgba(180,35,24,0.06) inset",
      }}
    >
      {taken ? "TAKEN" : "NOT TAKEN"}
    </Box>
  );
}

function buildSelectedPounceTitleNode(args: {
  row: PounceWindowRow;
  insightsToCvPlayerIndex: PlayerIndexMap;
  renderPlayerIdentity: RenderPlayerIdentity;
  fontColor?: string;
}): React.ReactNode {
  const {
    row,
    insightsToCvPlayerIndex,
    renderPlayerIdentity,
    fontColor = "black",
  } = args;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        flexWrap: "wrap",
        fontWeight: 700,
      }}
    >
      {buildPounceTakenBadge(row)}

      <Box sx={{ display: "inline-block" }}>
        <Box sx={{ display: "inline-block" }}>
          Pounce Opportunity on rally {row.rallyIndex + 1} from shot{" "}
          {getTriggerShotNumber(row)}
        </Box>{" "}
        for
      </Box>

      <Box
        sx={{
          display: "inline-block",
          alignItems: "center",
        }}
      >
        {renderPlayerIdentity({
          playerId: row.focusedPlayerId,
          size: 36,
          fontSize: 14,
          borderRadius: 6,
          fontColor,
        })}
      </Box>

      <Box>from</Box>

      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
        }}
      >
        {renderPlayerIdentity({
          playerId: row.opponentPlayerId,
          size: 28,
          fontSize: 14,
          borderRadius: 6,
          fontColor,
        })}
      </Box>
    </Box>
  );

  //   return (
  //     <Box
  //       sx={{
  //         display: "flex",
  //         alignItems: "center",
  //         gap: 1,
  //         flexWrap: "wrap",
  //         fontWeight: 700,
  //       }}
  //     >
  //       <Box sx={{ display: "inline-block" }}>
  //         <Box sx={{ display: "inline-block" }}>
  //           Pounce Opportunity on rally {row.rallyIndex + 1} from shot{" "}
  //           {getTriggerShotNumber(row)}
  //         </Box>{" "}
  //         for
  //       </Box>

  //       <Box
  //         sx={{
  //           display: "inline-block",
  //           alignItems: "center",
  //         }}
  //       >
  //         {renderPlayerIdentity({
  //           //{renderIdentityFromInsightsPlayerId({
  //           //insightsPlayerId: row.focusedPlayerId,
  //           //insightsToCvPlayerIndex,
  //           //renderPlayerIdentity,
  //           playerId: row.focusedPlayerId, //insightsToCvPlayerIndex[row.focusedPlayerId] ?? row.focusedPlayerId,
  //           size: 36,
  //           fontSize: 14,
  //           borderRadius: 6,
  //           fontColor,
  //         })}
  //       </Box>

  //       <Box>from</Box>

  //       <Box
  //         sx={{
  //           display: "inline-flex",
  //           alignItems: "center",
  //         }}
  //       >
  //         {renderPlayerIdentity({
  //           // {renderIdentityFromInsightsPlayerId({
  //           //   insightsPlayerId: row.opponentPlayerId,
  //           //   insightsToCvPlayerIndex,
  //           //   renderPlayerIdentity,
  //           playerId: row.opponentPlayerId, //insightsToCvPlayerIndex[row.opponentPlayerId] ?? row.opponentPlayerId,
  //           size: 28,
  //           fontSize: 14,
  //           borderRadius: 6,
  //           fontColor,
  //         })}
  //       </Box>
  //     </Box>
  //   );
}
// function buildRecipientLabel(row: PounceWindowRow): string {
//   return `p${row.focusedPlayerId}`;
// }
export function PounceWindowsPopup(props: {
  insightsToCvPlayerIndex: PlayerIndexMap;
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;

  packageId: string;
  activeRallyIndex: number | null;

  rows: KitchenArrivalRow[];
  pounceWindowRows: PounceWindowRow[];

  renderPlayerIdentity: RenderPlayerIdentity;

  teamColor: (team: 0 | 1, alpha?: number) => string;
  playerIdToTeam?: (playerId: number | null) => 0 | 1 | null;
  teamName?: (team: 0 | 1) => string;
  firefightsClips: FirefightClip[]; // <-- NEW, for overlay in video
  firefightRallySet: Set<number>; // <-- NEW, for conditional overlay in timeline
  cvJson: CvJson | null;
}) {
  const {
    open,
    onClose,
    packageId,
    activeRallyIndex,
    rows,
    pounceWindowRows,
    insightsToCvPlayerIndex,
    renderPlayerIdentity,
    teamColor,
    playerIdToTeam,
    firefightsClips,
    firefightRallySet,
    cvJson,
  } = props;

//   console.error("pounceWindowRows", pounceWindowRows);

  const [pos, setPos] = React.useState<{ x: number; y: number }>({
    x: 18,
    y: 50,
  });

  const dragRef = React.useRef<{
    startX: number;
    startY: number;
    startPosX: number;
    startPosY: number;
    dragging: boolean;
  } | null>(null);

  const onMouseDownHeader = (e: React.MouseEvent) => {
    if (e.button !== 0) return;
    dragRef.current = {
      startX: e.clientX,
      startY: e.clientY,
      startPosX: pos.x,
      startPosY: pos.y,
      dragging: true,
    };
    e.preventDefault();
  };

  React.useEffect(() => {
    const onMove = (e: MouseEvent) => {
      const d = dragRef.current;
      if (!d?.dragging) return;

      const dx = e.clientX - d.startX;
      const dy = e.clientY - d.startY;

      const nextX = Math.max(
        0,
        Math.min(window.innerWidth - 260, d.startPosX + dx),
      );
      const nextY = Math.max(
        0,
        Math.min(window.innerHeight - 180, d.startPosY + dy),
      );

      setPos({ x: nextX, y: nextY });
    };

    const onUp = () => {
      if (dragRef.current) dragRef.current.dragging = false;
    };

    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseup", onUp);

    return () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseup", onUp);
    };
  }, [pos.x, pos.y]);

  const [selectedKey, setSelectedKey] = React.useState<string | null>(null);
  const [playerFilter, setPlayerFilter] = React.useState<number | "all">("all");

  const [initiatorFilter, setInitiatorFilter] = React.useState<number | "all">(
    "all",
  );

  const [zoneFilter, setZoneFilter] = React.useState<
    "all" | "transition" | "kitchen"
  >("all");
  const [typeFilter, setTypeFilter] = React.useState<
    "all" | PounceWindowRow["opportunityKind"]
  >("all");

  const [takeFilter, setTakeFilter] = React.useState<
    "all" | "taken" | "not_taken"
  >("all");

  const [rallyResultFilter, setRallyResultFilter] = React.useState<
    "all" | "won" | "lost"
  >("all");

  const [sortKey, setSortKey] = React.useState<PounceSortKey>("distanceMoved");
  const [sortDir, setSortDir] = React.useState<PounceSortDir>("desc");

  const toggleSort = React.useCallback((key: PounceSortKey) => {
    setSortKey((prevKey) => {
      if (prevKey === key) {
        setSortDir((prevDir) => (prevDir === "asc" ? "desc" : "asc"));
        return prevKey;
      }
      setSortDir(key === "rally" || key === "shot" ? "asc" : "desc");
      return key;
    });
  }, []);

  const filteredRows = React.useMemo(() => {
    return pounceWindowRows.filter((row) => {
      if (row.recipientTeamWonRally === null) {
        return false;
      }
      if (playerFilter !== "all" && row.focusedPlayerId !== playerFilter) {
        return false;
      }

      if (
        initiatorFilter !== "all" &&
        row.opponentPlayerId !== initiatorFilter
      ) {
        return false;
      }

      if (zoneFilter !== "all" && row.zoneAtOpponentImpact !== zoneFilter) {
        return false;
      }
      if (typeFilter !== "all" && row.opportunityKind !== typeFilter) {
        return false;
      }

      if (takeFilter !== "all" && row.pounceResult !== takeFilter) {
        return false;
      }
      if (rallyResultFilter === "won" && !row.recipientTeamWonRally) {
        return false;
      }
      if (rallyResultFilter === "lost" && row.recipientTeamWonRally) {
        return false;
      }

      return true;
    });
  }, [
    pounceWindowRows,
    playerFilter,
    initiatorFilter,
    zoneFilter,
    typeFilter,
    takeFilter,
    rallyResultFilter,
  ]);

  const sortedRows = React.useMemo(() => {
    const arr = [...filteredRows];

    arr.sort((a, b) => {
      let av = 0;
      let bv = 0;

      if (sortKey === "commit") {
        av = a.scores.commit ?? 0;
        bv = b.scores.commit ?? 0;
      } else if (sortKey === "readiness") {
        av = a.scores.readiness ?? 0;
        bv = b.scores.readiness ?? 0;
      } else if (sortKey === "time") {
        av = getPounceTimeFromContactMs(a) ?? Number.POSITIVE_INFINITY;
        bv = getPounceTimeFromContactMs(b) ?? Number.POSITIVE_INFINITY;
      } else if (sortKey === "initiator") {
        av = getStableInitiatorId(a, insightsToCvPlayerIndex);
        bv = getStableInitiatorId(b, insightsToCvPlayerIndex);
      } else if (sortKey === "recipient") {
        av = getStableRecipientId(a, insightsToCvPlayerIndex);
        bv = getStableRecipientId(b, insightsToCvPlayerIndex);
      } else if (sortKey === "shot") {
        av = a.shotIndex;
        bv = b.shotIndex;
      } else if (sortKey === "rally") {
        av = a.rallyIndex;
        bv = b.rallyIndex;
      } else if (sortKey === "distanceMoved") {
        av = a.movementToBestAttackPoint.distanceFeet ?? 0;
        bv = b.movementToBestAttackPoint.distanceFeet ?? 0;
      } else {
        av = a.rallyIndex * 1000 + a.shotIndex;
        bv = b.rallyIndex * 1000 + b.shotIndex;
      }

      const d = av - bv;
      return sortDir === "asc" ? d : -d;
    });

    return arr;
  }, [filteredRows, sortKey, sortDir]);

  const availableRecipientIds = React.useMemo(() => {
    const s = new Set<number>();

    for (const row of pounceWindowRows) {
      if (
        initiatorFilter !== "all" &&
        row.opponentPlayerId !== initiatorFilter
      ) {
        continue;
      }
      s.add(row.focusedPlayerId);
    }

    return Array.from(s).sort((a, b) => a - b);

    // return Array.from(s).sort(
    //   (a, b) =>
    //     (insightsToCvPlayerIndex[a] ?? a) - (insightsToCvPlayerIndex[b] ?? b),
    // );
  }, [pounceWindowRows, initiatorFilter, insightsToCvPlayerIndex]);

  const availableInitiatorIds = React.useMemo(() => {
    const s = new Set<number>();

    for (const row of pounceWindowRows) {
      if (playerFilter !== "all" && row.focusedPlayerId !== playerFilter) {
        continue;
      }
      s.add(row.opponentPlayerId);
    }

    return Array.from(s).sort((a, b) => a - b);

    // return Array.from(s).sort(
    //   (a, b) =>
    //     (insightsToCvPlayerIndex[a] ?? a) - (insightsToCvPlayerIndex[b] ?? b),
    // );
    // return Array.from(s).sort(
    //   (a, b) =>
    //     (insightsToCvPlayerIndex[a] ?? a) - (insightsToCvPlayerIndex[b] ?? b),
    // );
  }, [pounceWindowRows, playerFilter, insightsToCvPlayerIndex]);

  React.useEffect(() => {
    if (
      playerFilter !== "all" &&
      !availableRecipientIds.includes(playerFilter)
    ) {
      setPlayerFilter("all");
    }
  }, [playerFilter, availableRecipientIds]);

  React.useEffect(() => {
    if (
      initiatorFilter !== "all" &&
      !availableInitiatorIds.includes(initiatorFilter)
    ) {
      setInitiatorFilter("all");
    }
  }, [initiatorFilter, availableInitiatorIds]);

  //

  React.useEffect(() => {
    if (
      initiatorFilter !== "all" &&
      !availableInitiatorIds.includes(initiatorFilter)
    ) {
      setInitiatorFilter("all");
    }
  }, [initiatorFilter, availableInitiatorIds]);

  const pounceOpportunitiesByInitiatorId = React.useMemo(() => {
    const map: Record<number, PounceWindowRow[]> = {};
    for (const row of pounceWindowRows) {
      if (!map[row.opponentPlayerId]) {
        map[row.opponentPlayerId] = [];
      }
      map[row.opponentPlayerId].push(row);
    }
    return map;
  }, [pounceWindowRows]);

  React.useEffect(() => {
    if (!open) return;
    setSelectedKey(sortedRows[0]?.pointKey ?? null);
  }, [
    open,
    activeRallyIndex,
    playerFilter,
    zoneFilter,
    typeFilter,
    takeFilter,
    rallyResultFilter,
    sortKey,
    sortDir,
    sortedRows,
  ]);

  const selected =
    sortedRows.find((row) => row.pointKey === selectedKey) ??
    sortedRows[0] ??
    null;

  const selectedRallyRow = React.useMemo(() => {
    if (!selected) return null;
    return rows.find((r) => r.rallyIndex === selected.rallyIndex) ?? null;
  }, [rows, selected]);

  //   const selectedVideoStartMs =
  //     selectedRallyRow && selected?.opponentContact.ms != null
  //       ? Math.max(selectedRallyRow.startMs, selected.opponentContact.ms - 900)
  //       : (selectedRallyRow?.startMs ?? null);

  const [seedNonce, setSeedNonce] = React.useState(0);

  React.useEffect(() => {
    if (!selected) return;
    setSeedNonce((n) => n + 1);
  }, [selected?.pointKey]);

  const pounceLoopRegionMs = React.useMemo(() => {
    if (!selected || !selectedRallyRow) return null;

    const candidateStarts = [
      selected.opponentContact?.ms,
      selected.attackBand?.entryMs,
      selected.attackBand?.firstAttackablePoint?.ms,
      selected.attackBand?.bestAttackPoint?.ms,
    ].filter((v): v is number => typeof v === "number" && Number.isFinite(v));

    const candidateEnds = [
      selected.attackBand?.exitMs,
      selected.attackBand?.bestAttackPoint?.ms,
      selected.attackBand?.firstAttackablePoint?.ms,
      selected.opponentContact?.ms,
    ].filter((v): v is number => typeof v === "number" && Number.isFinite(v));

    if (!candidateStarts.length || !candidateEnds.length) return null;

    const anchorStart = Math.min(...candidateStarts);
    const anchorEnd = Math.max(...candidateEnds);

    const startMs = Math.max(selectedRallyRow.startMs, anchorStart - 450);
    const endMs = Math.min(selectedRallyRow.endMs, anchorEnd + 550);

    if (endMs <= startMs) return null;

    return {
      startMs,
      endMs,
    };
  }, [selected, selectedRallyRow]);

  const pounceLoopRegionMs_oldold = React.useMemo(() => {
    if (!selected || !selectedRallyRow) return null;

    const candidateStarts = [
      selected.opponentContact?.ms,
      selected.attackBand?.entryMs,
      selected.attackBand?.bestAttackPoint?.ms,
      // selected.recipientWindow?.entryMs,
      // selected.recipientWindow?.startMs,
    ].filter((v): v is number => typeof v === "number" && Number.isFinite(v));

    const candidateEnds = [
      selected.attackBand?.exitMs,
      selected.attackBand?.bestAttackPoint?.ms,
      // selected.recipientWindow?.exitMs,
      // selected.recipientWindow?.endMs,
      selected.opponentContact?.ms,
    ].filter((v): v is number => typeof v === "number" && Number.isFinite(v));

    if (!candidateStarts.length || !candidateEnds.length) return null;

    const earliestMs = Math.max(...candidateStarts);
    const latestMs = Math.min(...candidateEnds);

    const startMs = Math.min(selectedRallyRow.startMs, earliestMs - 800);
    const endMs = Math.max(selectedRallyRow.endMs, latestMs + 800);

    return {
      startMs,
      endMs,
    };
  }, [selected, selectedRallyRow]);

  const pounceLoopRegionMs_old = React.useMemo(() => {
    if (!selected || !selectedRallyRow) return null;

    const triggerMs =
      selected.opponentContact?.ms ?? selected.attackBand?.entryMs ?? null;

    const entryMs = selected.attackBand?.entryMs ?? triggerMs;

    const exitMs =
      selected.attackBand?.exitMs ??
      selected.attackBand?.bestAttackPoint?.ms ??
      triggerMs;

    if (triggerMs == null || entryMs == null || exitMs == null) return null;

    const startMs = Math.max(
      selectedRallyRow.startMs,
      Math.min(triggerMs, entryMs) - 1000,
    );

    const endMs = Math.min(selectedRallyRow.endMs, exitMs + 1500);

    return {
      startMs,
      endMs,
    };
  }, [selected, selectedRallyRow]);

  const selectedWindowStartMs =
    selected?.attackBand.entryMs ??
    selected?.attackBand.firstAttackablePoint?.ms ??
    selected?.attackBand.bestAttackPoint?.ms ??
    selected?.opponentContact.ms ??
    null;

  const selectedVideoStartMs =
    pounceLoopRegionMs?.startMs ?? selectedRallyRow?.startMs ?? null;

  //   const selectedVideoStartMs =
  //     selectedRallyRow && selectedWindowStartMs != null
  //       ? Math.max(selectedRallyRow.startMs, selectedWindowStartMs)
  //       : (selectedRallyRow?.startMs ?? null);

  const selectedWindowEndMs =
    selected?.attackBand.exitMs ??
    selected?.attackBand.bestAttackPoint?.ms ??
    null;

  const selectedVideoEndMs =
    selectedRallyRow && selectedWindowEndMs != null
      ? Math.min(selectedRallyRow.endMs, selectedWindowEndMs + 900)
      : (selectedRallyRow?.endMs ?? null);

  //   const selectedOverlayStartMs =
  //     selectedRallyRow && selected?.opponentContact.ms != null
  //       ? Math.max(selectedRallyRow.startMs, selected.opponentContact.ms - 220)
  //       : (selectedVideoStartMs ?? null);

  //   const selectedOverlayEndMs = selectedRallyRow
  //     ? Math.min(
  //         selectedRallyRow.endMs,
  //         (selected?.attackBand.exitMs ??
  //           selected?.attackBand.bestAttackPoint?.ms ??
  //           selectedVideoEndMs ??
  //           selectedRallyRow.endMs) + 650,
  //       )
  //     : null;

  const selectedOverlayStartMs = selectedRallyRow
    ? Math.max(
        selectedRallyRow.startMs,
        (selected?.attackBand.entryMs ??
          selected?.attackBand.firstAttackablePoint?.ms ??
          selected?.opponentContact.ms ??
          selectedVideoStartMs ??
          selectedRallyRow.startMs) - 700,
      )
    : null;

  const selectedOverlayEndMs = selectedRallyRow
    ? Math.min(
        selectedRallyRow.endMs,
        (selected?.attackBand.exitMs ??
          selected?.attackBand.bestAttackPoint?.ms ??
          selected?.attackBand.firstAttackablePoint?.ms ??
          selected?.opponentContact.ms ??
          selectedVideoEndMs ??
          selectedRallyRow.endMs) + 1000,
      )
    : null;

  const popupToggleSx = {
    textTransform: "none",
    minHeight: 30,
    px: 1,
    py: 0.25,
    fontSize: 12,
    fontWeight: 700,
    borderColor: "rgba(0,0,0,0.14)",
    color: "rgba(0,0,0,0.76)",
    "&.Mui-selected": {
      backgroundColor: "rgba(0,0,0,0.07)",
      color: "rgba(0,0,0,0.92)",
    },
    "&.Mui-selected:hover": {
      backgroundColor: "rgba(0,0,0,0.11)",
    },
  } as const;

  const filterLabelSx = {
    fontSize: 11,
    fontWeight: 800,
    opacity: 0.58,
    minWidth: 66,
    flexShrink: 0,
  } as const;

  if (!open) return null;

  return (
    <Paper
      data-happy-path="pounce-popup"
      elevation={10}
      sx={{
        position: "fixed",
        left: pos.x,
        top: pos.y,
        width: "calc(100vw - 36px)",
        maxWidth: "calc(100vw - 36px)",
        height: "95vh",
        maxHeight: "calc(100vh - 120px)",
        borderRadius: 2,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        zIndex: 2000,
        border: "1px solid rgba(0,0,0,0.14)",
      }}
    >
      <Box
        sx={{
          px: 1.5,
          py: 1,
          paddingBottom: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          //   borderBottom: "1px solid rgba(0,0,0,0.12)",
          cursor: "grab",
          "&:active": { cursor: "grabbing" },
        }}
        onMouseDown={onMouseDownHeader}
      >
        {/* <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
          <Box sx={{ fontWeight: 700, fontSize: 16 }}>
            <Box sx ={{display: "inline-block",}}>
            <PounceCatIcon size={40} />
            </Box>
            <Box sx ={{display: "inline-block",marginLeft:"8px"}}>
            Pounce Opportunities
            </Box>
            </Box>
        </Box> */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              fontWeight: 700,
              fontSize: 16,
            }}
          >
            <Box sx={{ display: "inline-block", opacity: 0.7 }}>
              <PounceCatIcon size={40} borderRadius={6} />
            </Box>
            <Box sx={{ ml: 2 }}>Pounce Opportunities</Box>
          </Box>
        </Box>

        <Box
          onClick={onClose}
          sx={{
            width: 28,
            height: 28,
            borderRadius: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            "&:hover": { background: "rgba(0,0,0,0.06)" },
          }}
        >
          <CloseIcon fontSize="small" />
        </Box>
      </Box>

      <Box
        sx={{
          px: 1.25,
          py: 0.85,
          display: "flex",
          flexDirection: "column",
          gap: 0.75,
          borderBottom: "1px solid rgba(0,0,0,0.08)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            flexWrap: "wrap",
          }}
        >
          <Box sx={filterLabelSx}>Recipient</Box>

          <ToggleButtonGroup
            exclusive
            size="small"
            value={playerFilter}
            onChange={(_, value) => {
              if (value == null) return;
              setPlayerFilter(value);
            }}
          >
            <ToggleButton value="all" sx={popupToggleSx}>
              Any
            </ToggleButton>

            {availableRecipientIds.map((playerId) => {
              const count = pounceWindowRows.filter((row) => {
                if (row.focusedPlayerId !== playerId) return false;
                if (
                  initiatorFilter !== "all" &&
                  row.opponentPlayerId !== initiatorFilter
                ) {
                  return false;
                }
                return true;
              }).length;

              return (
                <ToggleButton
                  key={playerId}
                  value={playerId}
                  sx={popupToggleSx}
                >
                  <Box
                    sx={{ display: "flex", alignItems: "center", gap: 0.75 }}
                  >
                    {renderPlayerIdentity({
                      //renderIdentityFromInsightsPlayerId({
                      //  insightsToCvPlayerIndex,
                      //  renderPlayerIdentity,
                      playerId: playerId, //] ?? playerId,
                      size: 38,
                      fontSize: 10,
                      borderRadius: 6,
                    })}
                  </Box>
                  <Box sx={{ ml: "4px" }}>({count})</Box>
                </ToggleButton>
              );
            })}
          </ToggleButtonGroup>

          <Box sx={{ ...filterLabelSx, ml: 0.5 }}>Initiator</Box>

          <ToggleButtonGroup
            exclusive
            size="small"
            value={initiatorFilter}
            onChange={(_, value) => {
              if (value == null) return;
              setInitiatorFilter(value);
            }}
          >
            <ToggleButton value="all" sx={popupToggleSx}>
              Any
            </ToggleButton>

            {availableInitiatorIds.map((playerId) => {
              const count = pounceWindowRows.filter((row) => {
                if (row.opponentPlayerId !== playerId) return false;
                if (
                  playerFilter !== "all" &&
                  row.focusedPlayerId !== playerFilter
                ) {
                  return false;
                }
                return true;
              }).length;

              return (
                <ToggleButton
                  key={playerId}
                  value={playerId}
                  sx={popupToggleSx}
                >
                  <Box
                    sx={{ display: "flex", alignItems: "center", gap: 0.75 }}
                  >
                    {renderPlayerIdentity({
                      //playerId: insightsToCvPlayerIndex[playerId] ?? playerId,
                      //renderIdentityFromInsightsPlayerId({
                      //  insightsToCvPlayerIndex,
                      //  renderPlayerIdentity,
                      playerId: playerId, //insightsToCvPlayerIndex[playerId] ?? playerId,
                      size: 38,
                      fontSize: 10,
                      borderRadius: 6,
                    })}
                  </Box>
                  <Box sx={{ ml: "4px" }}>({count})</Box>
                </ToggleButton>
              );
            })}
          </ToggleButtonGroup>
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            flexWrap: "wrap",
          }}
        >
          <Box sx={filterLabelSx}>Opportunity</Box>

          <ToggleButtonGroup
            exclusive
            size="small"
            value={takeFilter}
            onChange={(_, value) => {
              if (!value) return;
              setTakeFilter(value);
            }}
          >
            <ToggleButton value="all" sx={popupToggleSx}>
              All
            </ToggleButton>
            <ToggleButton value="taken" sx={popupToggleSx}>
              Taken
            </ToggleButton>
            <ToggleButton value="not_taken" sx={popupToggleSx}>
              Not Taken
            </ToggleButton>
          </ToggleButtonGroup>

          <Box sx={{ ...filterLabelSx, minWidth: 52, ml: 0.5 }}>Result</Box>

          <ToggleButtonGroup
            exclusive
            size="small"
            value={rallyResultFilter}
            onChange={(_, value) => {
              if (!value) return;
              setRallyResultFilter(value);
            }}
          >
            <ToggleButton value="all" sx={popupToggleSx}>
              All
            </ToggleButton>
            <ToggleButton value="won" sx={popupToggleSx}>
              Won
            </ToggleButton>
            <ToggleButton value="lost" sx={popupToggleSx}>
              Lost
            </ToggleButton>
          </ToggleButtonGroup>
        </Box>
      </Box>

      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          display: "grid",
          //gridTemplateColumns: "700px 1fr",
          gridTemplateColumns: "600px 1fr",
        }}
      >
        <Box
          sx={{
            minWidth: 0,
            borderRight: "1px solid rgba(0,0,0,0.08)",
            overflow: "auto",
          }}
        >
          <Table
            size="small"
            stickyHeader
            sx={{
              "& .MuiTableCell-root": {
                borderBottom: "1px solid rgba(0,0,0,0.06)",
                verticalAlign: "middle",
              },
            }}
          >
            {/* <TableHead>
              <TableRow>
                <TableCell
                  sx={{ width: 94, cursor: "pointer" }}
                  onClick={() => toggleSort("commit")}
                >
                  Strength
                </TableCell>
                <TableCell sx={{ width: 188 }}>Type / Recipient</TableCell>
                <TableCell sx={{ width: 156 }}>Trigger</TableCell>
                <TableCell sx={{ width: 104 }}>Zone</TableCell>
                <TableCell sx={{ width: 152 }}>Move</TableCell>
                <TableCell
                  sx={{ width: 88, cursor: "pointer" }}
                  onClick={() => toggleSort("time")}
                >
                  Time
                </TableCell>
                <TableCell
                  sx={{ width: 92, cursor: "pointer" }}
                  onClick={() => toggleSort("rally")}
                >
                  Rally
                </TableCell>
              </TableRow>
            </TableHead> */}

            <TableHead>
              <TableRow>
                {/* <TableCell
                  sx={{ width: 94, cursor: "pointer" }}
                  onClick={() => toggleSort("commit")}
                >
                  Strength
                </TableCell> */}

                {/* <TableCell sx={{ width: 150 }}>Type</TableCell> */}

                <TableCell
                  sx={{ cursor: "pointer", userSelect: "none", width: 92 }}
                  onClick={() => toggleSort("distanceMoved")}
                >
                  Distance
                </TableCell>

                <TableCell
                  sx={{ width: 132 }}
                  onClick={() => toggleSort("initiator")}
                >
                  Initiator
                </TableCell>

                <TableCell
                  sx={{ width: 132 }}
                  onClick={() => toggleSort("recipient")}
                >
                  Recipient
                </TableCell>

                {/* <TableCell sx={{ width: 104 }}>Zone</TableCell> */}

                {/* <TableCell sx={{ width: 152 }}>Move</TableCell> */}

                {/* <TableCell
      sx={{ width: 88, cursor: "pointer" }}
      onClick={() => toggleSort("time")}
    >
      Time
    </TableCell> */}

                <TableCell sx={{ width: 112 }}>Taken</TableCell>

                <TableCell sx={{ width: 92 }}>Rally Result</TableCell>

                <TableCell
                  sx={{ width: 92, cursor: "pointer" }}
                  onClick={() => toggleSort("rally")}
                >
                  Rally
                </TableCell>
                <TableCell
                  sx={{ width: 92, cursor: "pointer" }}
                  onClick={() => toggleSort("shot")}
                >
                  Shot
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {sortedRows.map((row) => {
                const selectedThis = row.pointKey === selected?.pointKey;
                const strength = buildPounceStrength(row);
                const team =
                  playerIdToTeam?.(row.focusedPlayerId) ??
                  teamOfPlayer(row.focusedPlayerId);

                return (
                  <TableRow
                    key={row.pointKey}
                    hover
                    selected={selectedThis}
                    onClick={() => setSelectedKey(row.pointKey)}
                    sx={{
                      cursor: "pointer",
                      background: selectedThis
                        ? teamColor(team, 0.14)
                        : "transparent",
                    }}
                  >
                    {/* <TableCell>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 0.25,
                        }}
                      >
                        <Box sx={{ fontWeight: 700, fontSize: 14 }}>
                          {strength.commit ?? "—"}
                        </Box>
                      </Box>
                    </TableCell> */}

                    <TableCell sx={{ width: 92 }}>
                      {typeof row.movementToBestAttackPoint.distanceFeet ===
                      "number"
                        ? `${row.movementToBestAttackPoint.distanceFeet.toFixed(1)} ft`
                        : "—"}
                    </TableCell>

                    <TableCell>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 0.35,
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.6,
                          }}
                        >
                          {renderPlayerIdentity({
                            //playerId:
                            //  insightsToCvPlayerIndex[row.opponentPlayerId],
                            //renderIdentityFromInsightsPlayerId({
                            //insightsToCvPlayerIndex,
                            //renderPlayerIdentity,
                            playerId: row.opponentPlayerId, //insightsToCvPlayerIndex[row.opponentPlayerId] ?? row.opponentPlayerId,
                            //insightsPlayerId: row.opponentPlayerId,
                            //   insightsToCvPlayerIndex[row.opponentPlayerId], // ?? row.opponentPlayerId,
                            size: 40,
                            fontSize: 11,
                            borderRadius: 5,
                          })}
                          <Box sx={{ fontSize: 12, fontWeight: 600 }}>
                            {`p${row.opponentPlayerId}`}
                            {/* {toDisplayPlayerLabel(
                              row.opponentPlayerId,
                              insightsToCvPlayerIndex,
                            )} */}
                          </Box>
                          {/* <Box sx={{ fontSize: 12, fontWeight: 600 }}>
        {buildInitiatorLabel(row)}
      </Box> */}
                        </Box>

                        {/* <Box sx={{ fontSize: 11, opacity: 0.7 }}>
      {buildInitiatorSubLabel(row)}
    </Box> */}
                      </Box>
                    </TableCell>

                    <TableCell>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 0.35,
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.6,
                          }}
                        >
                          {renderPlayerIdentity({
                            //     playerId:
                            //       insightsToCvPlayerIndex[row.focusedPlayerId],
                            //renderIdentityFromInsightsPlayerId({
                            //insightsToCvPlayerIndex,
                            //renderPlayerIdentity,
                            playerId: row.focusedPlayerId,
                            //   insightsToCvPlayerIndex[row.focusedPlayerId], // ?? row.focusedPlayerId,
                            size: 40,
                            fontSize: 11,
                            borderRadius: 5,
                          })}

                          <Box sx={{ fontSize: 12, fontWeight: 600 }}>
                            {/* {toDisplayPlayerLabel(
                              row.focusedPlayerId,
                              insightsToCvPlayerIndex,
                            )} */}
                            {`p${row.focusedPlayerId}`}
                            {/* {JSON.stringify(insightsToCvPlayerIndex)} */}
                          </Box>

                          {/* <Box sx={{ fontSize: 12, fontWeight: 600 }}>
        {buildRecipientLabel(row)}
      </Box> */}
                        </Box>
                      </Box>
                    </TableCell>

                    {/* <TableCell>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 0.35,
                        }}
                      >
                        <Box sx={{ fontSize: 12, fontWeight: 600 }}>
                          {buildTriggerLabel(row)}
                        </Box>
                        <Box sx={{ fontSize: 11, opacity: 0.72 }}>
                          {row.opponentContact.ms != null
                            ? `at ${Math.round(row.opponentContact.ms)} ms`
                            : "trigger"}
                        </Box>
                      </Box>
                    </TableCell> */}

                    {/* <TableCell>
                      <Box sx={{ fontSize: 12 }}>
                        {row.zoneAtOpponentImpact === "transition"
                          ? "Transition"
                          : row.zoneAtOpponentImpact === "kitchen"
                            ? "Kitchen"
                            : "Other"}
                      </Box>
                      <Box sx={{ fontSize: 11, opacity: 0.7 }}>
                        {fmtFeet(
                          row.playerAtOpponentImpact.distanceToKitchenLineFeet,
                        )}
                      </Box>
                    </TableCell> */}

                    {/* <TableCell>
                      <Box sx={{ fontSize: 12 }}>
                        {buildPounceMoveLabel(row)}
                      </Box>
                    </TableCell> */}

                    {/* <TableCell>
                      <Box sx={{ fontSize: 12 }}>
                        {buildPounceTimeLabel(row)}
                      </Box>
                      <Box sx={{ fontSize: 11, opacity: 0.7 }}>
                        {row.attackBand.bestAttackPoint?.z != null
                          ? `z ${row.attackBand.bestAttackPoint.z.toFixed(1)}`
                          : "—"}
                      </Box>
                    </TableCell> */}

                    <TableCell>
                      <Box
                        sx={{
                          fontSize: 12,
                          fontWeight: 700,
                          color:
                            row.pounceResult === "taken"
                              ? "rgba(46, 125, 50, 0.95)"
                              : "rgba(80, 80, 80, 0.92)",
                        }}
                      >
                        {buildTakenLabel(row)}
                      </Box>
                    </TableCell>

                    <TableCell>
                      <Box
                        sx={{
                          fontSize: 12,
                          fontWeight: 700,
                          color: row.recipientTeamWonRally
                            ? "rgba(46, 125, 50, 0.95)"
                            : "rgba(183, 28, 28, 0.92)",
                        }}
                      >
                        {buildRallyResultLabel(row)}
                      </Box>
                    </TableCell>

                    <TableCell>
                      <Box sx={{ fontSize: 12 }}>{row.rallyIndex + 1}</Box>
                      {/* <Box sx={{ fontSize: 11, opacity: 0.7 }}>
                        {`S${row.shotIndex + 1}`}
                      </Box> */}
                    </TableCell>
                    <TableCell>
                      <Box sx={{ fontSize: 12 }}>{row.shotIndex + 1}</Box>
                      {/* <Box sx={{ fontSize: 11, opacity: 0.7 }}>
                        {`S${row.shotIndex + 1}`}
                      </Box> */}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Box>

        <Box
          sx={{
            minWidth: 0,
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              px: 1.25,
              py: 1,
              borderBottom: "1px solid rgba(0,0,0,0.08)",
              display: "flex",
              flexDirection: "column",
              gap: 0.6,
            }}
          >
            {selected ? (
              <>
                {/* <Box sx={{ fontWeight: 700, fontSize: 14 }}>
                  {buildSelectedPounceTitle(selected, insightsToCvPlayerIndex)}
                </Box> */}
                <Box sx={{ fontWeight: 700, fontSize: 14, lineHeight: 1.2 }}>
                  {buildSelectedPounceTitleNode({
                    row: selected,
                    insightsToCvPlayerIndex,
                    renderPlayerIdentity,
                  })}
                </Box>

                {/* <Box
                  sx={{
                    display: "flex",
                    gap: 2,
                    flexWrap: "wrap",
                    fontSize: 12,
                    opacity: 0.82,
                  }}
                >
                  <Box>{`Commit ${pct01To100(selected.scores.commit) ?? "—"}`}</Box>
                  <Box>{`Ready ${pct01To100(selected.scores.readiness) ?? "—"}`}</Box>
                  <Box>{`Feas ${pct01To100(selected.scores.feasibility) ?? "—"}`}</Box>
                  <Box>{`Move ${buildPounceMoveLabel(selected)}`}</Box>
                  <Box>{`Time ${buildPounceTimeLabel(selected)}`}</Box>
                  <Box>{`Window ${buildPounceWindowDurationLabel(selected)}`}</Box>
                  <Box>{buildTriggerLabel(selected)}</Box>
                  <Box>{buildRecipientLabel(selected, insightsToCvPlayerIndex)}</Box>
                </Box> */}
              </>
            ) : (
              <Box sx={{ opacity: 0.7 }}>No pounce opportunities</Box>
            )}
          </Box>

          <Box sx={{ flex: 1, minHeight: 0, overflow: "hidden" }}>
            {selected &&
            selectedRallyRow &&
            selectedVideoStartMs != null &&
            selectedVideoEndMs != null ? (
              <ActiveRallyVideo
                titleNode={
                  selected
                    ? buildSelectedPounceTitleNode({
                        row: selected,
                        insightsToCvPlayerIndex,
                        renderPlayerIdentity,
                        fontColor: "white",
                      })
                    : null
                }
                cvJson={cvJson}
                key={selected.pointKey}
                insightsToCvPlayerIndex={insightsToCvPlayerIndex}
                renderPlayerIdentity={renderPlayerIdentity}
                aiContextLabel="Pounce opportunity analysis"
                focusedFilter={null}
                packageId={packageId}
                row={selectedRallyRow}
                rows={rows}
                activeShotNumber={selected.shotIndex + 1}
                seekToActiveShotOnChange={false}
                showCondensedTimeline={false}
                fontColor={"white"}
                controlsPlacement={"left"}
                firefightsClips={firefightsClips}
                firefightRallySet={firefightRallySet}
                showRateControls={true}
                showTitle={false}
                showScoreEtc={false}
                showAi={true}
                aiDrawerMode={"split"}
                showLoopScrubber={true}
                defaultLoopUiOpen={false}
                showPopoutButton={true}
                isInFullPopup={false}
                autoPlayOnRallyChange={true}
                seedPlayback={{
                  nonce: seedNonce,
                  timeSec: Math.max(
                    0,
                    ((selectedVideoStartMs ?? selectedRallyRow.startMs) -
                      (selectedRallyRow.segmentStartMs ??
                        selectedRallyRow.startMs ??
                        0)) /
                      1000,
                  ),
                  paused: false,
                }}
                focusedPlayerId={selected.focusedPlayerId}
                seedLoopRegion={
                  pounceLoopRegionMs && selectedRallyRow
                    ? {
                        enabled: true,
                        aSec:
                          (pounceLoopRegionMs.startMs -
                            (selectedRallyRow.segmentStartMs ??
                              selectedRallyRow.startMs ??
                              0)) /
                          1000,
                        bSec:
                          (pounceLoopRegionMs.endMs -
                            (selectedRallyRow.segmentStartMs ??
                              selectedRallyRow.startMs ??
                              0)) /
                          1000,
                        nonce: seedNonce,
                      }
                    : undefined
                }
                pounceOverlay={{
                  enabled: true,
                  pounceResult: selected.pounceResult,
                  focusedPlayerId: selected.focusedPlayerId,
                  opponentPlayerId: selected.opponentPlayerId,
                  triggerShotNumber: getTriggerShotNumber(selected),
                  overlayStartMs: selectedOverlayStartMs,
                  overlayEndMs: selectedOverlayEndMs,
                  opponentContact: selected.opponentContact,
                  playerAtOpponentImpact: selected.playerAtOpponentImpact,
                  firstAttackablePoint:
                    selected.attackBand.firstAttackablePoint,
                  bestAttackPoint: selected.attackBand.bestAttackPoint,

                  pounceShotTrajectory: {
                    start: selected?.pounceShotTrajectory?.start ?? null,
                    peak: selected.pounceShotTrajectory?.peak ?? null,
                    end: selected.pounceShotTrajectory?.end ?? null,
                  },

  pounceShotNumber:
    selected.pounceResult === "taken" ? selected.shotIndex + 2 : null,
  pounceShotStartMs:
    selected.pounceShotTrajectory?.start?.ms ?? null,
  pounceShotEndMs:
    selected.pounceShotTrajectory?.end?.ms ?? null,

                  entryMs: selected.attackBand.entryMs,
                  exitMs: selected.attackBand.exitMs,
                  movementDistanceFeet:
                    selected.movementToBestAttackPoint.distanceFeet,
                  movementDirection:
                    selected.movementToBestAttackPoint.direction,
                  peakPoint: {
                    x: selected.ballGeometry.peakX,
                    y: selected.ballGeometry.peakY,
                    z: selected.ballGeometry.peakZ,
                  },
                  peakHeightOverNet: selected.ballGeometry.peakHeightOverNet,

                  requiredMovement: {
                    enabled: true,
                    startPoint:
                      selected.playerAtOpponentImpact.x != null &&
                      selected.playerAtOpponentImpact.y != null
                        ? {
                            x: selected.playerAtOpponentImpact.x,
                            y: selected.playerAtOpponentImpact.y,
                          }
                        : null,
                    endPoint:
                      selected.attackBand.bestAttackPoint?.x != null &&
                      selected.attackBand.bestAttackPoint?.y != null
                        ? {
                            x: selected.attackBand.bestAttackPoint.x,
                            y: selected.attackBand.bestAttackPoint.y,
                          }
                        : selected.attackBand.firstAttackablePoint?.x != null &&
                            selected.attackBand.firstAttackablePoint?.y != null
                          ? {
                              x: selected.attackBand.firstAttackablePoint.x,
                              y: selected.attackBand.firstAttackablePoint.y,
                            }
                          : null,
                    firstAttackablePoint:
                      selected.attackBand.firstAttackablePoint?.x != null &&
                      selected.attackBand.firstAttackablePoint?.y != null
                        ? {
                            x: selected.attackBand.firstAttackablePoint.x,
                            y: selected.attackBand.firstAttackablePoint.y,
                          }
                        : null,
                    bestAttackPoint:
                      selected.attackBand.bestAttackPoint?.x != null &&
                      selected.attackBand.bestAttackPoint?.y != null
                        ? {
                            x: selected.attackBand.bestAttackPoint.x,
                            y: selected.attackBand.bestAttackPoint.y,
                          }
                        : null,
                    distanceFeet:
                      selected.movementToBestAttackPoint.distanceFeet,
                    dxFeet: selected.movementToBestAttackPoint.dxFeet,
                    dyFeet: selected.movementToBestAttackPoint.dyFeet,
                    direction: selected.movementToBestAttackPoint.direction,
                  },
                }}
              />
            ) : (
              //   <ActiveRallyVideo
              //     key={selected.pointKey}
              //     // row={selectedRallyRow}
              //     // rows={rows}
              //     // packageId={packageId}
              //     //rallyIndex={selected.rallyIndex}

              //     insightsToCvPlayerIndex={insightsToCvPlayerIndex}
              //     renderPlayerIdentity={renderPlayerIdentity}
              //     aiContextLabel="Pounce window analysis"
              //     focusedFilter={null}
              //     packageId={packageId}
              //     row={selectedRallyRow}
              //     rows={rows}
              //     activeShotNumber={selected.shotIndex + 1}
              //     showCondensedTimeline={false}
              //     fontColor={"white"}
              //     controlsPlacement={"left"}
              //     firefightsClips={firefightsClips}
              //     firefightRallySet={firefightRallySet}
              //     showRateControls={true}
              //     showTitle={false}
              //     showScoreEtc={false}
              //     showAi={true}
              //     aiDrawerMode={"split"}
              //     showLoopScrubber={true}
              //     defaultLoopUiOpen={false}
              //     showPopoutButton={false}
              //     isInFullPopup={false}
              //     seedPlayback={{
              //       nonce: seedNonce,
              //       timeSec:
              //         (selectedVideoStartMs ?? selectedRallyRow.startMs) / 1000,
              //       paused: true,
              //       //   startMs: selectedVideoStartMs,
              //       //   endMs: selectedVideoEndMs,
              //     }}
              //     //showShotNumbers
              //     // later:
              //     // pounceWindowRow={selected}
              //     // overlayMode="pounce"
              //   />
              <Box
                sx={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  opacity: 0.64,
                }}
              >
                Nothing selected
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </Paper>
  );
}
